import React from 'react';
import { Typography } from '@material-ui/core';

export default function DetailSearch() {
    return (
        <Typography style={{ fontFamily: "Playfair Display"}} variant='h6' color='primary'>Filter results:</Typography>
    )
}


